import { css } from '@emotion/css';
import CloseButton from '../../common/CloseButton';

import { StyledText } from '@repo/ui/atoms';
import { useTranslationsContext } from '../../utils/TranslationsContext';
import { QuestionWrapperStyle } from '../stepsStyle';

const NoSlotsLeft = () => {
    const { t } = useTranslationsContext();

    return (
        <div className={Container}>
            <StyledText as="h2" variant="h3">
                {t('calendarStep.noSlotsLeft')}
            </StyledText>
            <CloseButton />
        </div>
    );
};

const Container = css`
    ${QuestionWrapperStyle};
    align-items: center;
    gap: 0px;
`;

export default NoSlotsLeft;
